export default class ConfirmationDirective {
    constructor($uibModal, translateService) {
        this.$uibModal = $uibModal;

        this.restrict = 'A';

        this.priority = 0;

        this.terminal = true;

        this.translate = translateService;
    }

    link(scope, element, attrs, controllers) {
        const message = attrs.confirmationMessage || this.translate.t('are_you_sure');

        const modalConfirmation = (e) => {
            e.preventDefault();

            const url = e.currentTarget.href || e.target.parentElement.href;
            const ngClick = attrs.ngClick;

            var modalInstance = this.$uibModal.open({
                animation: 'false',
                size: 'md',
                template: '<div class="modal-confirmation">\
                                <div class="modal-header">\
                                    <h3 class="modal-title" id="modal-title">{{ \'confirmation\' | t }}</h3>\
                                </div>\
                                <div class="modal-body" id="modal-body">\
                                    {{ message }}\
                                </div>\
                                <div class="modal-footer">\
                                    <button class="btn btn-success" type="button" ng-click="yes()">{{ \'yes\' | t }}</button>\
                                    <button class="btn btn-danger" type="button" ng-click="no()">{{ \'cancel\' | t }}</button>\
                                </div>\
                            </div>',
                controller: ['$scope', '$uibModalInstance', 'message', function($scope, $uibModalInstance, message) {
                    $scope.message = message;

                    $scope.yes = function () {
                        $uibModalInstance.close();
                    };

                    $scope.no = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
                resolve: {
                    message: function () {
                        return message;
                    }
                }
            });

            modalInstance.result.then(function () {
                if (typeof ngClick === 'undefined') {
                    if (url !== '') {
                        window.location.href = url;
                    }
                } else {
                    scope.$eval(ngClick)
                }
            }, function () {});
        }

        element.bind('click', modalConfirmation);
    }

    static directiveFactory($uibModal) {
        'ngInject';

        return new ConfirmationDirective($uibModal);
    }
}
